import Home from '../../pages/home/index.vue'
import nHomeList from '../../pages/nHome/list'
import nHomeDetail from '../../pages/nHome/detail'
import Choose from '../../pages/choose/index.vue'
import List from '../../pages/choose/list.vue'
import Profile from '../../pages/choose/profile.vue'
import Mine from '../../pages/mine/index.vue'
import Video from '../../pages/video/index.vue'
import Game from '../../pages/game/index.vue'

// navigation 页面路由：统一公开路径及路由名称，组件和 meta 保持不变。
const routes = [
  { path: '/', redirect: '/home', component: Home, meta: { title: '' } },
  { path: '/home', name: 'home', component: Home, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/discover/list', name: 'discover-list', component: nHomeList, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/discover/detail', name: 'discover-detail', component: nHomeDetail, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/profiles', name: 'profiles', component: Choose, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/profiles/list', name: 'profiles-list', component: List, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/profiles/detail', name: 'profiles-detail', component: Profile, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/account', name: 'account', component: Mine, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/videos', name: 'videos', component: Video, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/games', name: 'games', component: Game, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
]

export default routes
